/**
 * useSearchGames
 */

import {
    useState,
    useCallback,
} from 'react';

import {
    Queries,
    ApolloLib,
} from 'bdvp-graphql';
import { useLang } from '../config';

const { useQuery } = ApolloLib;
const { SEARCH_GAMES } = Queries;

const useSearchGames = (searchQuery, searchOptions = {}) => {

    const {
        ssr = false,
        skip = !searchQuery,
        limit = 36,
        contentPreference,
        searchPage = 0,
        queryType,
    } = searchOptions;

    const lang = useLang();

    const [
        page,
        setPage,
    ] = useState(searchPage);

    const [
        loadingMore,
        setLoadingMore,
    ] = useState(false);

    const {
        loading,
        data,
        error,
        fetchMore,
    } = useQuery(
        SEARCH_GAMES,
        {
            variables: {
                query: searchQuery,
                limit,
                page: searchPage,
                languagePreference: lang.toUpperCase(),
                contentPreference,
                queryType,
            },
            errorPolicy: 'all',
            ssr,
            skip,
        }
    );

    const fetchMoreData = useCallback(() => {

        const nextPage = page + 1;

        setLoadingMore(true);

        return fetchMore({
            variables: {
                page: nextPage,
            },
            updateQuery: (prev, { fetchMoreResult }) => {

                setLoadingMore(false);
                setPage(nextPage);

                if (!fetchMoreResult) return prev;

                return Object.assign({}, prev, {
                    search: {
                        plays: [
                            ...prev.search.plays,
                            ...fetchMoreResult.search.plays,
                        ],
                        total: fetchMoreResult.search.total,
                        __typename: 'PagedClipDetails',
                    },
                });

            },
        });

    }, [
        fetchMore,
        page,
        setPage,
    ]);

    return {
        loading,
        loadingMore,
        data,
        error,
        fetchMoreData,
        page,
        limit,
        hasMore: data?.search?.total > data?.search?.plays?.length,
    };

};

export default useSearchGames;
